import { RefObject, useEffect, useRef } from "react"
import { createGroupIconFunction, createMarkerIcon } from "./marker-icon"
import L from "leaflet"
import "leaflet.markercluster"
import { IActivity } from "../../shared-interfaces/activity"

const template = `
  <div class="map-y-widget gyg">
    <div class="map-y-picture-container">
      <div class="map-y-picture" style="{largerImageBgUrl}"></div>
    </div>
    <div class="map-y-text-container">
      <h5 class="map-y-title" tabindex="0">
        <span class="map-y-title-text">{title}</span>
      </h5>
      <div class="map-y-badge {certifiedCss}">
        <span class="map-y-badge-text">Zertifiziert</span>
      </div>
      <div class="map-y-duration">Dauer:&#32; {durationDesc}</div>
      <div class="map-y-rating-price-table">
        <div class="map-y-rating-price-column">
          <div class="map-y-rating {ratingCss}">{rating}</div>
          <div class="map-y-review-count">{reviewCount} Bewertungen</div>
        </div>
        <div class="map-y-rating-price-column">
            <span class="map-y-price">
              <span class="map-y-price-from">Ab</span> 
              <span class="map-y-price-min">{minimumPriceStr}&nbsp;€</span> 
           </span>
      </div>
    </div>
    <a
      href="{url}?psrc=widget&version=2&partner_id=MLC854H&cmp={gygCmp}&currency=EUR"
      tabindex="0" target="_blank" class="map-y-link">
      <span class="map-y-link-text">Details ansehen</span></a>
  </div>
`

const roundToNextPointFive = (activity: IActivity) => Math.round(activity.rating * 2) / 2

export const useActivitiesEffect = (activities: IActivity[] | null, mapVisible: boolean, showPrice: boolean, map: RefObject<L.Map>) => {

  const markers = useRef<any>(null)

  useEffect(() => {

    if (markers.current && map.current) {
      map.current.removeLayer(markers.current)
    }

    if (mapVisible && activities) {
      markers.current = L.markerClusterGroup({
        maxClusterRadius: 50,
        showCoverageOnHover: false,
        iconCreateFunction: createGroupIconFunction(showPrice, "activity"),
      })

      activities.forEach((activity: any) => {
        const smallImageUrl = activity.imageUrl.replace("-148", "-38")
        const smallImageBgUrl = `background-image: url(${smallImageUrl})`

        const minimumPriceStr = activity.minimumPrice.toLocaleString()

        const priceInfo = {
          price: activity.minimumPrice,
          minimumPriceStr: minimumPriceStr,
        }

        const marker = L.marker(activity.latLng, {
          // @ts-ignore
          smallImageBgUrl,
          priceInfo,
          activity,
          icon: createMarkerIcon(showPrice, "activity", smallImageBgUrl, priceInfo),
        })

        marker.bindPopup((currentMarker: any) => {
          const currentActivity = currentMarker.options.activity
          const popupPriceInfo = currentMarker.options.priceInfo

          return L.Util.template(template, {
            largerImageBgUrl: "background-image: url(" + currentActivity.imageUrl.replace("-148", "-38") + ")",
            title: currentActivity.title,
            certifiedCss: currentActivity.certified ? "is-certified" : "is-not-certified",
            durationDesc: currentActivity.durationDesc || "",
            ratingCss: "map-y-rating" + (Number(roundToNextPointFive(currentActivity).toFixed(1)) * 10),
            rating: currentActivity.rating,
            reviewCount: currentActivity.reviewCount,
            minimumPriceStr: popupPriceInfo.minimumPriceStr,
            url: currentActivity.url,
            gygCmp: "yovelino",
          })

        }, {
          className: "leaflet-popup-yovelino",
          maxWidth: 236,
          minWidth: 236,
        }).openPopup()

        markers.current.addLayer(marker)
      })

      map.current!.addLayer(markers.current)
    }
  }, [activities, mapVisible, showPrice, map])
}
